import { LoadingButton } from "@mui/lab";
import { Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useState } from "react";
import { AddOnItemName, SubscriptionType } from "schemas/dashboard";

import { getPageName } from "constants/trackingProps";
import SubscriptionStatusText from "features/Home/UpgradeDialog/Plan/SubscriptionStatusText";
import { PlanAction } from "features/Home/UpgradeDialog/Plan/helpers";
import { trackEvent } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import CardWrapper from "../components/CardWrapper";
import CustomEmailBenefits from "./CustomEmailBenefits";
import ManageCustomEmailDialog from "./ManageCustomEmailDialog";

const AddOnCustomEmail = () => {
  const { subscription, addOns, setCustomDomainDialog, setPlan } =
    useContext(SubscriptionContext);
  const { checkoutLoading, onPlanButtonClick } = useSubscription();

  const [manageDialog, setManageDialog] = useState(false);

  const managePlan = () => {
    setManageDialog(true);
    setPlan(AddOnItemName.custom_email);
  };

  const getButtonName = (): {
    title: string;
    action: () => void;
  } => {
    if (subscription && subscription?.customEmailData) {
      if (
        subscription?.customEmailData?.cancelAt &&
        subscription?.customEmailData?.status === SubscriptionType.ACTIVE
      ) {
        return {
          title: "Renew",
          action: () =>
            onPlanButtonClick(AddOnItemName.custom_email, PlanAction.renew),
        };
      } else if (
        subscription?.customEmailData?.status === SubscriptionType.CANCELED
      ) {
        return {
          title: "Resubscribe",
          action: handleCheckout,
        };
      } else if (
        subscription?.customEmailData?.status === SubscriptionType.INCOMPLETE
      ) {
        return {
          title: "Retry",
          action: handleCheckout,
        };
      } else {
        return {
          title: "Manage Add-on",
          action: managePlan,
        };
      }
    } else {
      return {
        title: "Purchase",
        action: handleCheckout,
      };
    }
  };

  const handleCheckout = async () => {
    trackEvent("Set up a Professional Email Button Clicked", {
      Source: getPageName(),
      "Is Add On Section": true,
    });
    setCustomDomainDialog(true);
  };

  if (
    !subscription ||
    !subscription?.customEmailData ||
    (subscription?.customEmailData?.status !== SubscriptionType.ACTIVE &&
      subscription?.customEmailData?.status !== SubscriptionType.PAST_DUE)
  ) {
    return <></>;
  }

  return (
    <CardWrapper>
      <Grid item>
        <Typography variant="h5" gutterBottom component="div">
          Custom Email + Custom Domain
        </Typography>

        <Typography variant="h6" sx={{ color: "green.main" }} gutterBottom>
          ${addOns?.[AddOnItemName.custom_email]?.price.toFixed(2)}
          /mo
        </Typography>

        <Typography gutterBottom>
          Get a professional Gmail inbox with your own domain — fully set up by
          Bento. We'll monitor your spam score and step in if your account ever
          gets blocked.
        </Typography>
        <CustomEmailBenefits />
        <SubscriptionStatusText
          status={
            subscription?.customEmailData?.status || SubscriptionType.TRIALING
          }
          cancelAt={subscription?.customEmailData?.cancelAt}
        />
      </Grid>
      <Grid item>
        <LoadingButton
          onClick={getButtonName()?.action}
          disableElevation
          sx={{
            px: 2,
            color:
              getButtonName()?.title === "Purchase" ? "white" : "primary.main",
            backgroundColor:
              getButtonName()?.title === "Purchase"
                ? "primary.main"
                : "#f4f8f6",
          }}
          loading={checkoutLoading === AddOnItemName.custom_email}
        >
          {getButtonName()?.title}
        </LoadingButton>

        <ManageCustomEmailDialog
          open={manageDialog}
          loading={checkoutLoading === AddOnItemName.custom_email}
          onClose={() => setManageDialog(false)}
        />
      </Grid>
    </CardWrapper>
  );
};

export default AddOnCustomEmail;
